<markant-dialog
  class="invite-member-dialog"
  [headTitle]="'organization.users.invite.header' | transloco"
  [open]="true"
  (close)="closeUserInviteDialog()"
>
  <markant-platform-organization-member-invitation-stepper
    [currentStep]="currentStep"
  ></markant-platform-organization-member-invitation-stepper>

  <markant-seperator class="horizontal-separator"></markant-seperator>

  <div class="content-wrapper">
    <div class="steps-content">
      <markant-platform-organization-member-invitation-step-header
        [step]="currentStep"
      >
      </markant-platform-organization-member-invitation-step-header>

      @if (currentStep === OrganizationMemberInvitationSteps.USER) {
        <div class="content-container">
          <markant-platform-registration-user
            [outlined]="true"
            [showError]="showError"
            [userForm]="userForm"
          ></markant-platform-registration-user>

          <markant-seperator class="separator" orientation="vertical">
          </markant-seperator>

          <form [formGroup]="userExtraDataForm">
            @if (userExtraDataForm.controls['department']; as department) {
              <markant-select
                class="form-input-selection"
                name="department"
                [options]="departmentAffiliationOptions"
                [formControlName]="'department'"
                [label]="'organization.users.department' | transloco"
                [outlined]="true"
                [required]="true"
                [showLabelHint]="true"
                [error]="
                  department.errors
                    | formControlKeyError
                      : 'error.validation.required'
                      : showError || department.touched || department.dirty
                      : true
                    | transloco
                "
                [helper]="''"
              >
              </markant-select>
            }

            @if (userExtraDataForm.controls['position']; as position) {
              <markant-input
                class="form-input-selection"
                id="position"
                data-cy="input-position"
                name="position"
                required
                [error]="
                  position.errors
                    | formControlError
                      : showError || position.touched || position.dirty
                "
                [formControlName]="'position'"
                [errorText]="
                  position.errors
                    | formControlKeyError
                      : 'error.validation.required'
                      : showError || position.touched || position.dirty
                      : true
                    | transloco
                "
                [label]="'organization.users.position' | transloco"
                [outlined]="true"
                [showLabelHint]="true"
              >
              </markant-input>
            }

            @if (userExtraDataForm.controls['language']; as language) {
              <markant-select
                class="form-input-selection"
                name="language"
                [options]="languageOptions"
                [outlined]="true"
                [required]="true"
                [showLabelHint]="true"
                [formControlName]="'language'"
                [label]="'organization.users.language' | transloco"
                [error]="
                  language.errors
                    | formControlKeyError
                      : 'error.validation.required'
                      : showError || language.touched || language.dirty
                      : true
                    | transloco
                "
                [helper]="''"
              >
              </markant-select>
            }
          </form>
        </div>
      }

      @if (currentStep === OrganizationMemberInvitationSteps.ROLE) {
        <div class="content-container">
          <markant-select
            class="form-input-selection"
            id="organizationRole"
            name="organizationRole"
            required
            [formControl]="organizationRoleControl"
            [options]="roleOptions"
            [outlined]="true"
            [showLabelHint]="true"
            [label]="
              'organization.users.invite.roleView.organizationRole' | transloco
            "
            [error]="
              organizationRoleControl.errors
                | formControlKeyError
                  : 'error.validation.required'
                  : showError ||
                      organizationRoleControl.touched ||
                      organizationRoleControl.dirty
                  : true
                | transloco
            "
            [helper]="''"
          >
          </markant-select>

          <markant-seperator class="separator" orientation="vertical">
          </markant-seperator>

          <img
            [src]="'assets/images/invite/invite-assign-platform-role.svg'"
            alt="Assign group"
          />
        </div>
      }

      @if (currentStep === OrganizationMemberInvitationSteps.GROUP) {
        @if (hasOrganizationGroups) {
          <markant-platform-organization-member-invitation-add-group
            data-cy="member-invitation-add-group"
            [invitationGroups]="invitationGroups"
            [invitationGroupsSelected]="invitationGroupsSelected()"
            (clicked)="onGroupClick($event)"
          ></markant-platform-organization-member-invitation-add-group>
        } @else {
          <div class="no-groups-info">
            <h4>
              {{
                'organization.users.invite.groupView.noGroupsInfo' | transloco
              }}
            </h4>
          </div>
        }
      }

      @if (currentStep === OrganizationMemberInvitationSteps.CARTRIDGE) {
        <markant-platform-cartridge-role-assignment
          data-cy="cartridge-role-assignment"
          class="cartridge-roles-assignment"
          [organizationId]="organizationId | defaultValue"
        ></markant-platform-cartridge-role-assignment>
      }
    </div>
  </div>

  <div
    [ngClass]="
      currentStep !== OrganizationMemberInvitationSteps.USER
        ? 'flex-spaced-between'
        : 'flex-row-end'
    "
    slot="markant-dialog-footer"
    class="button-wrapper"
  >
    @if (currentStep !== OrganizationMemberInvitationSteps.USER) {
      <markant-button
        class="mr-2"
        colorScheme="primary"
        variant="clear"
        data-cy="button-back"
        [loading]="isLoading"
        (click)="backwardsStep()"
        (keydown.enter)="backwardsStep()"
      >
        <markant-icon
          class="back-button-icon"
          icon="m_arrow-left"
          slot="icon-leading"
        ></markant-icon>
        {{ 'common.back' | transloco }}
      </markant-button>
    }

    <markant-button
      colorScheme="primary"
      data-cy="button-proceed"
      [loading]="isLoading"
      (click)="proceedStep()"
      (keydown.enter)="proceedStep()"
    >
      @if (currentStep === OrganizationMemberInvitationSteps.CARTRIDGE) {
        <span>
          {{ 'organization.users.invite.submit' | transloco }}
        </span>
      } @else if (
        currentStep === OrganizationMemberInvitationSteps.GROUP &&
        !invitationGroupsSelected().length
      ) {
        <span>
          {{ 'common.skip' | transloco }}
        </span>
      } @else {
        <span>
          {{ 'common.next' | transloco }}
        </span>
      }
    </markant-button>
  </div>
</markant-dialog>
